import vueUIInitiator from '../../modules/vue-ui-initiator';
import vueAppInitiator from '../../modules/vue-app-initiator';
import CareerContentSlider from '../../vue-components/CareerContentSlider';
import TabsProjectF from '../../vue-components/TabsProjectF';
import AccordionF from '../../vue-components/AccordionF';

const vueApps = [
    {
        el: '#tabs-project-f',
        components: { TabsProjectF }
    }
];
vueAppInitiator(vueApps);
vueUIInitiator('js--accordion-f', AccordionF, 'accordion-f');
vueUIInitiator('js--career-content-slider', CareerContentSlider, 'career-content-slider');
/**
 * При переходе к форме страницы при следующей перезагрузки страница откручивается в топ
 */
// eslint-disable-next-line func-names
window.onunload = function () {
    window.scrollTo(0, 0);
};

document.addEventListener("DOMContentLoaded", () => {
    const videoPreview = document.getElementById('video-preview');
    const videoPlay = document.getElementById('video-play');
    const videoContent = document.getElementById('video-content');

    videoPreview.addEventListener('click', () => {
        playVideo();
    });

    videoPlay.addEventListener('click', () => {
        playVideo();
    });

    function playVideo () {
        const videoIFrameLink = videoContent.dataset.src;
        const videoFrameContent = `<iframe id="video-iframe" src="${videoIFrameLink}" width="100%" height="100%" frameborder="0" allowfullscreen="1" allow="autoplay; encrypted-media; fullscreen; picture-in-picture"></iframe>`;
        videoPreview.style.display = 'none';
        videoPlay.style.display = 'none';
        videoContent.innerHTML = videoFrameContent;
    }
});

/**
 * Vanilla JavaScript Scroll to Anchor
 */
// eslint-disable-next-line func-names
(function () {
    // eslint-disable-next-line func-names
    const smoothScroll = function (targetEl, duration) {
        const headerElHeight = document.querySelector('#header-nav').clientHeight;
        const target = document.querySelector(targetEl);
        const targetPosition = target.getBoundingClientRect().top - headerElHeight;
        const startPosition = window.pageYOffset;
        let startTime = null;

        // eslint-disable-next-line func-names
        const ease = function (t, b, c, d) {
            // eslint-disable-next-line no-param-reassign
            t /= d / 2;
            if (t < 1) return (c / 2) * t * t + b;
            // eslint-disable-next-line no-param-reassign
            t--;
            return (-c / 2) * (t * (t - 2) - 1) + b;
        };

        // eslint-disable-next-line func-names
        const animation = function (currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const run = ease(timeElapsed, startPosition, targetPosition, duration);
            window.scrollTo(0, run);
            if (timeElapsed < duration) requestAnimationFrame(animation);
        };
        requestAnimationFrame(animation);
    };

    // eslint-disable-next-line func-names
    const scrollTo = function () {
        const links = document.querySelectorAll('.js--scroll');
        links.forEach((each) => {
            // eslint-disable-next-line func-names
            each.addEventListener('click', function (event) {
                event.preventDefault();
                const currentTarget = this.getAttribute('href');
                smoothScroll(currentTarget, 400);
            });
        });
    };
    scrollTo();
}());
